<template>
    <div>
       <v-card class="mt-2">
           <v-card-title class="subtitle-1">{{$t('labels.CLI_PreAuthDebt')}}</v-card-title>
           <v-card-text>
             <v-row no-gutters class="mt-4">
                      <span v-html="$t('messages.CLI_PremiumPayment')"></span> 
            </v-row>   
               <v-row col="12">
                  <v-col lg="3" sm="6" md="3">
                      <v-text-field
                        v-model="paymentDetail.FinancialInstitution"
                        :label="$t('labels.CLI_FinancialInstitution')"
                        required  
                        @keypress="isNumber($event)"  
                        @keyup="finChanged()"                     
                        :rules="minIns"></v-text-field>
                  </v-col>
                  <v-col lg="1" sm="6" md="3">
                     <v-btn dark color="primary" @click="verify()"  :disabled="verifyDisabled">{{$t('labels.CLI_Verify')}}</v-btn>
                  </v-col>
                  <v-col lg="4" sm="6" md="3">
                         <v-alert type="success" v-if="this.selectedInstitute !==null">{{this.selectedInstitute.Label}}</v-alert>
                         <v-alert type="error" v-if="this.showInvalidFinCodeMessage">{{$t("messages.CLI_NotValidFinCode")}}</v-alert>                      
                  </v-col>
               </v-row>
               <v-row col="12">
                  <v-col lg="3" sm="6" md="3">
                      <v-text-field
                        v-model="paymentDetail.Transit"
                        :label="$t('labels.CLI_TransitNumber')"
                        maxlength="5"
                        required  
                         @keypress="isNumber($event)"  
                        :disabled="disabled"                     
                        :rules="minTransit"></v-text-field>
                  </v-col>
               </v-row>
               <v-row col="12">
                  <v-col lg="3" sm="6" md="3">
                      <v-text-field
                        v-model="paymentDetail.AccountNumber"
                        :label="$t('labels.CLI_AccountNumber')"
                        maxlength="12"
                        required  
                         @keypress="isNumber($event)"  
                        :disabled="disabled"                     
                        :rules="minAccountNumber"></v-text-field>
                  </v-col>
               </v-row>
           </v-card-text>
       </v-card>
    </div>
</template>
<script>
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import domainHelper from "@/services/domainHelper";
export default {
   props:["paymentDetail"],
    data(){
        return{
            instituteCodes:[],
            disabled: true,
            selectedInstitute:null,
            showInvalidFinCodeMessage:false,
            isSubmitted:false,
            siteId: this.$route.params.siteid,
            verifyDisabled:true,
            minIns:[
                v=> !!v || '',
                v=> !isNaN(v) || '',
                v=> (v!== null && v.toString().length === 3) || this.$t('errors.CLI_Institution_Number')
            ],
            minTransit:[
                v=> !!v || '',
                v=> !isNaN(v) || '',
                v=> (v!==null && v.toString().length === 5) || this.$t('errors.CLI_Transit_Number')
            ],
            minAccountNumber:[
                v=> !!v || '',
                v=> !isNaN(v) || '',
                v=> (v!==null && v.toString().length >= 7 && v.toString().length <= 12) || this.$t('errors.CLI_Account_Number')
            ]         
        }
    },  
    created(){
         this.enableVerifyButton()
    },
     mounted(){        
        var lanID = localStorageSvc.getLan();
        dataSvc.getHttp().post(domainHelper.getAPIHost() + "/cli-api/"+ this.siteId + "/load-dd", {LanguageID:lanID, MenuCode:'FINCODE'})
        .then((res) => {
              this.instituteCodes = res.data;
            }
        )
    },
    methods:{
        enableVerifyButton(){
            this.verifyDisabled = this.paymentDetail == null 
                    || this.paymentDetail.FinancialInstitution == null 
                    || this.paymentDetail.FinancialInstitution.length === 0;
            
        },
         isNumber(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[0-9]+$/.test(char)) {               
                 return true;
              }
            else { e.preventDefault();}
        },        
         finChanged(){
            if(this.selectedInstitute && this.selectedInstitute.Value ==  this.paymentDetail.FinancialInstitution){
                return;
            }

            this.selectedInstitute = null;
            this.disabled = true;
            this.paymentDetail.Transit = "";
            this.paymentDetail.AccountNumber = "";
             this.enableVerifyButton()
            
       },
         verify(){
         let $this = this;
         let result = this.instituteCodes.filter(function(item){ 
               let value = $this.paymentDetail.FinancialInstitution
               return  /^\d+$/.test(value) &&  item.Value === parseInt(value)
           });        
           
           this.selectedInstitute = null;
           this.showInvalidFinCodeMessage = this.disabled = result.length === 0;
           if(!this.disabled){
               this.selectedInstitute = result[0];
           }
       },
    }   
}
</script>
<style scoped>
 .v-label::after {
    content: "*";
    color: red;
    margin-left: 2px;
  }
</style>